<template>
  <div>
    <slide-y-up-transition mode="out-in" origin="center top">
      <router-view></router-view>
    </slide-y-up-transition>
  </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false
      }
    }
  }
</script>
<style scoped>
</style>
